import { useTranslation } from "react-i18next";

export default function Testimonials() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-100">
      <div className="max-w-[720px] mx-auto text-center">
        {/* Title */}
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-10">
          &#40;{t("testimonials.title")}&#41;
        </h2>

        {/* Rating badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-foreground-950 text-white mb-8">
          <i className="ri-star-fill text-accent-500 text-sm"></i>
          <span className="text-sm font-semibold font-label">{t("testimonials.rating")}</span>
        </div>

        {/* Quote */}
        <blockquote className="font-heading text-xl md:text-2xl italic text-foreground-700 leading-relaxed mb-10 max-w-[600px] mx-auto">
          &ldquo;{t("testimonials.quote")}&rdquo;
        </blockquote>

        {/* Author */}
        <div className="flex items-center justify-center gap-3">
          <div className="w-11 h-11 rounded-full bg-accent-200 flex items-center justify-center overflow-hidden">
            <span className="font-heading text-base font-bold text-accent-800">MS</span>
          </div>
          <div className="text-left">
            <p className="text-sm font-semibold text-foreground-900">{t("testimonials.author")}</p>
            <p className="text-xs text-foreground-500">{t("testimonials.role")}</p>
          </div>
        </div>

        {/* Navigation arrows */}
        <div className="flex items-center justify-center gap-3 mt-10">
          <button className="w-10 h-10 rounded-lg border border-foreground-200 flex items-center justify-center text-foreground-500 hover:bg-foreground-50 transition-colors cursor-pointer">
            <i className="ri-arrow-left-line"></i>
          </button>
          <button className="w-10 h-10 rounded-lg bg-foreground-950 flex items-center justify-center text-white hover:bg-foreground-800 transition-colors cursor-pointer">
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}